<template>
  <div class="container">
    <img src="../../assets/Escape/living_room.png" class="image" />
    <img src="../../assets/Escape/box.png" id="box" />
    <img
      src="../../assets/Escape/envelope.png"
      id="envelope"
      @click="toggleIntro"
    />
    <transition name="fade">
      <Intro
        v-if="displayIntro"
        class="modale"
        @close="displayIntro = false"
        @next="$emit('goToPartTwo')"
      />
    </transition>
  </div>
</template>

<script>
import Intro from "./Intro.vue";

export default {
  name: "LivingRoom",
  components: {
    Intro,
  },
  data() {
    return {
      displayIntro: false,
      displayContest: true,
    };
  },
  methods: {
    toggleIntro() {
      this.displayIntro = this.displayIntro ? false : true;
    },
    setUser(value) {
      this.$emit("setUser", value);
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  width: 100%;
  position: relative;
}
.image {
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  cursor: zoom-in;
}
#box {
  position: absolute;
  bottom: 6%;
  right: 50%;
  height: 18%;
}
#envelope {
  position: absolute;
  bottom: 14%;
  right: 40%;
  height: 5%;
}
#envelope:hover {
  opacity: 0.8;
  cursor: zoom-in;
}
#box:hover {
  cursor: not-allowed;
}
.modale {
  position: absolute;
  top: 10%;
  height: auto;
  max-height: 75%;
  right: 25%;
  width: 50%;
}
</style>
